import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get("/wishlist").then(r => setItems(r.data)).finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="wishlist-guard">
        <p className="font-serif text-3xl mb-4">Sign in to view favourites</p>
        <Link to="/login" className="bg-[#4A1525] text-[#FAF8F5] px-8 py-4 overline">Sign in</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16" data-testid="wishlist-page">
      <div className="overline text-[#4A1525] mb-4">Your list</div>
      <h1 className="font-serif text-5xl md:text-7xl mb-12">Favourites</h1>
      {loading ? <p className="text-[#5C5C5C]">Loading...</p> :
        items.length === 0 ? (
          <div className="py-24 text-center">
            <p className="font-serif text-2xl mb-4">Nothing saved yet.</p>
            <Link to="/shop" className="overline underline underline-offset-4">Browse the edit</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
            {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )
      }
    </div>
  );
}
